export default __webpack_public_path__ + "static/media/warningTriangleSm.d8b202d5.svg";